// extracted by mini-css-extract-plugin
export default {"pageTitle":"style_pageTitle__AM4bB","content":"style_content__fcwIY","contentContainer":"style_contentContainer__DQcvZ"};